import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emailtemplate" }
const _hoisted_2 = { class: "form-group row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Title", -1)
const _hoisted_4 = { class: "col-sm-9" }
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Report type", -1)
const _hoisted_7 = { class: "col-sm-4" }
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Target", -1)
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Chron order", -1)
const _hoisted_13 = { class: "col-sm-4" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "To be sent before (in days)", -1)
const _hoisted_16 = { class: "col-sm-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label text-right" }, "Managed/Non-managed", -1)
const _hoisted_18 = { class: "col-sm-2" }
const _hoisted_19 = { class: "col-sm-2" }
const _hoisted_20 = { class: "dx-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Default", -1)
const _hoisted_22 = { class: "dx-field-value" }
const _hoisted_23 = { class: "form-group row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, null, -1)
const _hoisted_25 = { class: "col-sm-2" }
const _hoisted_26 = { class: "dx-field" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "CC to agent", -1)
const _hoisted_28 = { class: "dx-field-value" }
const _hoisted_29 = { class: "col-sm-2" }
const _hoisted_30 = { class: "dx-field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "CC to landlord", -1)
const _hoisted_32 = { class: "dx-field-value" }
const _hoisted_33 = { class: "form-group row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Subject", -1)
const _hoisted_35 = { class: "col-sm-9 subject-editor" }
const _hoisted_36 = { class: "form-group row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Message", -1)
const _hoisted_38 = { class: "col-sm-9 body-editor" }

import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { EmailTemplate, Dictionary } from "@/models";
import Editor from "ckeditor5/ckeditor";
import { DxSwitch} from 'devextreme-vue/switch';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailTemplateDetails',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

// State and Getters
const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
const emailtemplate = computed(() => store.getters['emailtemplates/current']);
const actProperty: any = inject('actProperty');

// Methods
const setEmailTemplate = (emailtemplate: EmailTemplate): void => {
  store.commit('emailtemplates/setEmailTemplate', emailtemplate);
};
const setEmailTemplateDeep = (payload: { path: string; data: any; }): Promise<any> => {
  return store.dispatch('emailtemplates/setEmailTemplateDeep', payload);
};

const addReporttype = (reporttype: string): Promise<any> => {
  return store.dispatch('emailtemplates/addReporttype', reporttype);
};
const setReporttypes = (reporttypes: string[]): Promise<any> => {
  return store.dispatch('emailtemplates/setReporttypes', reporttypes);
};

const addTarget = (target: string): Promise<any> => {
  return store.dispatch('emailtemplates/addTarget', target);
};

const addChronorder = (chronorder: string): Promise<any> => {
  return store.dispatch('emailtemplates/addChronorder', chronorder);
};

onMounted(async () => {
  if (isNewTemplate()) {
    setEmailTemplate(new EmailTemplate());
    return;
  }
});

// Computed properties
const bodyeditor = computed(() => Editor);
const bodyEditorConfig = computed(() => {
  return {
      placeholderConfig: {
        types: [
          "Access Branch",
          "Address",
          "Acknowledge Button",
          "Appointment time",
          "Booked with name",
          "Branch",
          "Client",
          "Client notes",
          "Confirm Callback Button",
          "Confirm No Button",
          "Confirm Yes Button",
          "Customer Relationship Manager DD Number",
          "Dataentry Report reference",
          "Dataentry delivery date/time",
          "Date",
          "Download Dataentry Files Button",
          "End time",
          "Invoice amount",
          "Landlord name",
          "Option 1 Button",
          "Option 2 Button",
          "Option 3 Button",
          "Option 4 Button",
          "Previous CI date",
          "Start time",
          "Tenant name",
          "Type of job external"
        ],
      },
      toolbar: {
        items: ['heading','|','bold','italic','link','|','alignment:left', 'alignment:right', 'alignment:center', 
        'alignment:justify','|','bulletedList','numberedList','|','insertTable','|','outdent', 'indent',
        '|','fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor','|','undo','redo','|', 'placeholder'],
      },
    };
});
const subjecteditor = computed(() => Editor);
const subjectEditorConfig = computed(() => {
  return {
      placeholderConfig: {
        types: [
          "Type of job external",
          "Address",
          "Booked with name",
          "Appointment time",
          "Client",
          "Branch",
          "Access Branch",
          "Date",
          "Start time",
          "End time",
          "Invoice amount",
          "Dataentry Report reference",
        ],
      },
      toolbar: {
        items: ["placeholder"],
      },
    };
});

const body = computed({
  get: () => emailtemplate.value.body,
  set: (data: string) => {
    setEmailTemplateDeep({
      path: 'body',
      data,
    });
  }
});

// Computed property for `reporttypes`
const reporttypes = computed({
  get: () => emailtemplate.value.reporttypes,
  set: (types: string[]) => {
    setReporttypes(types);
  }
});
const onSelectReporttype = (type: string) => {
  addReporttype(type);
}

// Computed property for `title`
const title = computed({
  get: () => emailtemplate.value.title,
  set: (data: string) => {
    setEmailTemplateDeep({
      path: 'title',
      data,
    });
  }
});

// Computed property for `subject`
const subject = computed({
  get: () => emailtemplate.value.subject,
  set: (data: string) => {
    setEmailTemplateDeep({
      path: 'subject',
      data,
    });
  }
});


const managedtypeOptions: string[] = ["Managed", "Non-managed"];

// Computed property for `managedtype`
const managedtype = computed({
  get: () => emailtemplate.value.managedtype,
  set: (data: string) => {
    setEmailTemplateDeep({
      path: 'managedtype',
      data,
    });
  }
});

// Computed property for `defaulttemplate`
const defaulttemplate = computed({
  get: () => emailtemplate.value.defaulttemplate,
  set: (data: boolean) => {
    setEmailTemplateDeep({
      path: 'defaulttemplate',
      data,
    });
  }
});

// Computed property for `cctoagent`
const cctoagent = computed({
  get: () => emailtemplate.value.cctoagent,
  set: (data: boolean) => {
    setEmailTemplateDeep({
      path: 'cctoagent',
      data,
    });
  }
});

// Computed property for `cctolandlord`
const cctolandlord = computed({
  get: () => emailtemplate.value.cctolandlord,
  set: (data: boolean) => {
    setEmailTemplateDeep({
      path: 'cctolandlord',
      data,
    });
  }
});

const editTemplate = (field: string, $event: any) => {
  setEmailTemplateDeep({
    path: field,
    data: $event.target.value,
  });
};
const reportTypes = computed((): string[] => {
  let list = ["inventory", "soc", "checkin", "checkout", "property visit"];
  if (dictionary.value && dictionary.value.reporttypes) {
    list = dictionary.value.reporttypes.map((t) => t.slug);
  }
  return list;
});

const formatReportType = (type: string) => {
  return actProperty.formatReportType(type, dictionary.value);
};

const targetList: string[] = [
  "Booked By",
  "Data Entry",
  "Managed Client",
  "Non-Managed Client",
  "Tenant",
  "Landlord",
  "Invoice",
];
const chronorderList: string[] = [
  "Initial confirmation",
  "First Chaser",
  "Second Chaser",
  "Third Chaser",
  "Fourth Chaser",
  "Fifth Chaser",
  "Sixth Chaser",
  "Last Minute",
  "Reminder",
  "Change Of Date",
  "Restore Booking",
  "Confirmed",
  "Not Confirmed",
  "Delete Booking",
  "Correspondance/Feedback to Client",
  "Issue Report"
];
const sortedChronorderlist = computed(() => chronorderList.sort())

// Computed property for `target`
const target = computed({
  get: () => emailtemplate.value.target,
  set: (data: string[]) => {
    setEmailTemplateDeep({
      path: 'target',
      data,
    });
  }
});

const onSelectTarget = (type: string) => {
  addTarget(type);
}

// Computed property for `chronorder`
const chronorder = computed({
  get: () => emailtemplate.value.chronorder,
  set: (data: string[]) => {
    setEmailTemplateDeep({
      path: 'chronorder',
      data,
    });
  }
});

const onSelectChronorder = (type: string) => {
  addChronorder(type);
}

// Computed property for `daysbefore`
const daysbefore = computed({
  get: () => emailtemplate.value.daysbefore,
  set: (data: number) => {
    setEmailTemplateDeep({
      path: 'daysbefore',
      data,
    });
  }
});

// Helper functions
const canSave = () => {
  return emailtemplate.value.subject && emailtemplate.value.body;
};

const isNewTemplate = () => {
  return (route.params.id as string) === "new";
};


return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_singleselect_text = _resolveComponent("singleselect-text")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event))
          }, null, 512), [
            [_vModelText, title.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_multiselect_text, {
            modelValue: reporttypes.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reporttypes).value = $event)),
            options: reportTypes.value,
            "allow-empty": true,
            taggable: false,
            "custom-label": formatReportType,
            multiple: "",
            onSelect: onSelectReporttype,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (editTemplate('type', $event)))
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_multiselect_text, {
            modelValue: target.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((target).value = $event)),
            options: targetList,
            "allow-empty": true,
            taggable: false,
            multiple: "",
            onSelect: onSelectTarget,
            onChange: _cache[4] || (_cache[4] = ($event: any) => (editTemplate('target', $event)))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_multiselect_text, {
            modelValue: chronorder.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((chronorder).value = $event)),
            options: sortedChronorderlist.value,
            "allow-empty": true,
            taggable: false,
            multiple: "",
            onSelect: onSelectChronorder,
            onChange: _cache[6] || (_cache[6] = ($event: any) => (editTemplate('chronorder', $event)))
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((daysbefore).value = $event))
          }, null, 512), [
            [_vModelText, daysbefore.value]
          ])
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_singleselect_text, {
            modelValue: managedtype.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((managedtype).value = $event)),
            options: managedtypeOptions
          }, _createSlots({ _: 2 }, [
            (managedtype.value)
              ? {
                  name: "clear",
                  fn: _withCtx(() => [
                    _createElementVNode("i", {
                      onMousedown: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (managedtype.value = ''), ["prevent","stop"])),
                      class: "multiselect__clear fa fa-times",
                      "aria-label": "Clear"
                    }, null, 32)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(DxSwitch), {
                value: defaulttemplate.value,
                onValueChanged: _cache[10] || (_cache[10] = ($event: any) => (setEmailTemplateDeep({path: 'defaulttemplate', data: $event.value})))
              }, null, 8, ["value"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_unref(DxSwitch), {
                value: cctoagent.value,
                onValueChanged: _cache[11] || (_cache[11] = ($event: any) => (setEmailTemplateDeep({path: 'cctoagent', data: $event.value})))
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_unref(DxSwitch), {
                value: cctolandlord.value,
                onValueChanged: _cache[12] || (_cache[12] = ($event: any) => (setEmailTemplateDeep({path: 'cctolandlord', data: $event.value})))
              }, null, 8, ["value"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_ckeditor, {
            editor: subjecteditor.value,
            modelValue: subject.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((subject).value = $event)),
            config: subjectEditorConfig.value
          }, null, 8, ["editor", "modelValue", "config"])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_ckeditor, {
            editor: bodyeditor.value,
            modelValue: body.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((body).value = $event)),
            config: bodyEditorConfig.value
          }, null, 8, ["editor", "modelValue", "config"])
        ])
      ])
    ])
  ]))
}
}

})